let arr=[
    {name:'待抽样',value:'待抽样'},
    {name:'待检测',value:'待检测'},
    {name:'已完成',value:'已完成'}
]
export default arr